import { createAction, props, union } from '@ngrx/store';
import {
  AccountPaymentMethod,
  PaymentPreviewErrorPayload,
  PaymentPreviewV1Response,
} from '@arc/unified-payments-frontend/shared-payment';
import { ExpirationDate } from '@arc/unified-payments-frontend/date-utils';

export const paymentPreviewUpdated = createAction(
  '[Pay On Invoice Select Payment Method] Payment Preview Updated',
  props<{ payload: PaymentPreviewV1Response }>(),
);

export const paymentPreviewError = createAction(
  '[Pay On Invoice Select Payment Method] Payment Preview Error',
  props<{ error: PaymentPreviewErrorPayload }>(),
);

export const isScheduledPaymentDateUpdated = createAction(
  '[Pay On Invoice Select Payment Method] Is Scheduled Payment Date Updated',
  props<{
    isScheduledPaymentDate: boolean;
    paymentMethodType: AccountPaymentMethod;
  }>(),
);

export const openAddPaymentMethodDialog = createAction(
  '[Pay On Invoice Select Payment Method] Open Add Payment Method Dialog',
);

export const closeAddPaymentMethodDialog = createAction(
  '[Pay On Invoice Select Payment Method] Close Add Payment Method Dialog',
);

export const cvvUpdated = createAction(
  '[Pay On Invoice Select Payment Method] CVV Updated',
  props<{ cvv: string }>(),
);

export const paymentAccountExpirationDateUpdated = createAction(
  '[Pay On Invoice Select Payment Method] Payment Account Expiration Date Updated',
  props<{ expirationDate: ExpirationDate }>(),
);

export const selectedPaymentAccountDeleted = createAction(
  '[Pay On Invoice Select Payment Method] Selected Payment Account Deleted',
);

const payOnInvoiceSelectPaymentMethodActions = union({
  paymentPreviewUpdated,
  paymentPreviewError,
  isScheduledPaymentDateUpdated,
  openAddPaymentMethodDialog,
  closeAddPaymentMethodDialog,
  cvvUpdated,
  paymentAccountExpirationDateUpdated,
  selectedPaymentAccountDeleted,
});

export type PayOnInvoiceSelectPaymentMethodActionsUnion =
  typeof payOnInvoiceSelectPaymentMethodActions;

export const PayOnInvoiceSelectPaymentMethodActions = {
  paymentPreviewUpdated,
  paymentPreviewError,
  isScheduledPaymentDateUpdated,
  openAddPaymentMethodDialog,
  closeAddPaymentMethodDialog,
  cvvUpdated,
  paymentAccountExpirationDateUpdated,
  selectedPaymentAccountDeleted,
};
